import _definePage_default_0 from '/vercel/path0/apps/payments/src/pages/:organizationSlug/invoice/[invoiceIds].vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/vercel/path0/apps/payments/src/pages/:organizationSlug/portal/[...partnerSlug]-[partnerId].vue?definePage&vue&lang.tsx'

export const routes = [
  {
    path: '/:organizationSlug',
    /* internal name: '/:organizationSlug' */
    /* no component */
    children: [
      {
        path: 'e',
        /* internal name: '/:organizationSlug/e' */
        /* no component */
        children: [
          {
            path: ':threadId',
            name: '/:organizationSlug/e/[threadId]',
            component: () => import('/vercel/path0/apps/payments/src/pages/:organizationSlug/e/[threadId].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'invoice',
        /* internal name: '/:organizationSlug/invoice' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':invoiceIds',
            name: 'invoice-checkout',
            component: () => import('/vercel/path0/apps/payments/src/pages/:organizationSlug/invoice/[invoiceIds].vue'),
            /* no children */
          },
  _definePage_default_0
  )
        ],
      },
      {
        path: 'portal',
        /* internal name: '/:organizationSlug/portal' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':partnerSlug(.*)-:partnerId',
            name: 'portal',
            component: () => import('/vercel/path0/apps/payments/src/pages/:organizationSlug/portal/[...partnerSlug]-[partnerId].vue'),
            children: [
              {
                path: '',
                name: '/:organizationSlug/portal/[...partnerSlug]-[partnerId]/',
                component: () => import('/vercel/path0/apps/payments/src/pages/:organizationSlug/portal/[...partnerSlug]-[partnerId]/index.vue'),
                /* no children */
              },
              {
                path: 'credit-memos',
                name: '/:organizationSlug/portal/[...partnerSlug]-[partnerId]/credit-memos',
                component: () => import('/vercel/path0/apps/payments/src/pages/:organizationSlug/portal/[...partnerSlug]-[partnerId]/credit-memos.vue'),
                /* no children */
              },
              {
                path: 'invoices',
                name: '/:organizationSlug/portal/[...partnerSlug]-[partnerId]/invoices',
                component: () => import('/vercel/path0/apps/payments/src/pages/:organizationSlug/portal/[...partnerSlug]-[partnerId]/invoices.vue'),
                /* no children */
              },
              {
                path: 'payments',
                name: '/:organizationSlug/portal/[...partnerSlug]-[partnerId]/payments',
                component: () => import('/vercel/path0/apps/payments/src/pages/:organizationSlug/portal/[...partnerSlug]-[partnerId]/payments.vue'),
                /* no children */
              }
            ],
          },
  _definePage_default_2
  )
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

